import { Button, Modal } from 'antd'
import React from 'react'

const ConfirmModal = ({
    title,
    isOpen,
    handleClose,
    onDelete,
    content,
    loading,
}) => {
    return (
        <Modal
            title={title}
            open={isOpen}
            onCancel={handleClose}
            footer={[
                <Button key="cancel" onClick={() => {
                    handleClose();
                }}>
                    Cancel
                </Button>,
                <Button
                    key="delete"
                    type="primary"
                    danger
                    onClick={onDelete}
                    loading={loading}
                >
                    Delete
                </Button>
            ]}
            width={400}
        >
            <div className="space-y-4">
                <div className="flex items-center gap-3">
                    <div>
                        <p className="text-sm text-gray-500 mt-1">
                           Are you sure? This action cannot be undone. The {content} will be permanently deleted.
                        </p>
                    </div>
                </div>
            </div>
        </Modal>

    )
}

export default ConfirmModal